import HTTP_GESCOM from '../HTTP_GESCOM';
import config from '../config/config';

export async function sendMail(params, data) {
  const response = await HTTP_GESCOM.post(`${config.URL_SERVEUR}Mail/EmailAsync`, data, {
    params: {
      mettreEdition: params.mettreEdition,
      societeId: params.societeId,
      typeDonnee: params.typeDonnee,
      elementId: params.elementId,
    },
  });
  return response;
}

